import { z } from "zod"

export const updateFlashcardSchema = z.object({
  question: z
    .string({
      required_error: "La pregunta es requerida",
    })
    .min(1, { message: "La pregunta debe tener al menos 1 carácter" }),
  answer: z
    .string({
      required_error: "La respuesta es requerida",
    })
    .min(1, { message: "La respuesta debe tener al menos 1 carácter" }),
})

export type UpdateFlashcardSchema = z.infer<typeof updateFlashcardSchema>
